module.exports = __webpack_public_path__ + "static/media/5-6.bf442f29.mp3";